import { render, staticRenderFns } from "./node3.vue?vue&type=template&id=6a3810a4&scoped=true&"
import script from "./node3.vue?vue&type=script&lang=js&"
export * from "./node3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3810a4",
  null
  
)

export default component.exports